var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3167 15.4549L16.7386 12.9344L16.6782 12.8425C16.5658 12.7306 16.4122 12.6676 16.2519 12.6676C16.0915 12.6676 15.9379 12.7306 15.8256 12.8425C13.6346 14.8525 10.2586 14.9618 7.9365 13.0978C5.6144 11.2338 5.06675 7.97502 6.65676 5.48263C8.24678 2.99023 11.4811 2.03764 14.2146 3.2566C16.9482 4.47557 18.3329 7.48784 17.4503 10.2957C17.3867 10.4985 17.4387 10.7191 17.5866 10.8744C17.7345 11.0296 17.9558 11.0959 18.1673 11.0483C18.3787 11.0007 18.5482 10.8464 18.6117 10.6436C19.6668 7.31148 18.0733 3.72567 14.8621 2.20579C11.6509 0.685921 7.78563 1.68812 5.76679 4.56406C3.74795 7.44001 4.18138 11.3266 6.7867 13.7096C9.39201 16.0926 13.3873 16.2569 16.1881 14.0962L18.4707 16.3279C18.7065 16.5574 19.0876 16.5574 19.3234 16.3279C19.5589 16.0952 19.5589 15.7204 19.3234 15.4877L19.3167 15.4549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.76ed35adfda6969d09bfeffaaf41f329.svg";
export { ForwardRef as ReactComponent };